(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-sizes"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__productCardQuickAdd) return;
    window.__productCardQuickAdd = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-quick-add-variant]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      var wrapper = button.closest('.product-card-sizes');
      if (!wrapper || wrapper.classList.contains('is-loading')) return;

      var baseItem = {};
      try {
        baseItem = JSON.parse(wrapper.getAttribute('data-layer') || '{}');
      } catch (e) {}

      var dataLayerItem = Object.assign({}, baseItem, {
        item_id: button.getAttribute('data-sku'),
        price: Number(button.getAttribute('data-price')),
        quantity: 1
      });

      var item = {
        id: Number(button.getAttribute('data-quick-add-variant')),
        quantity: 1,
        dataLayerItem: dataLayerItem
      };

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      function addToCart() {
        if (window.Cart && typeof window.Cart.add === 'function') {
          return window.Cart.add([item]);
        }
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: item.id, quantity: 1 }] })
        }).then(function (response) {
          if (!response.ok) throw new Error('add-to-cart failed');
          window.location.href = root + 'cart';
        });
      }

      wrapper.classList.add('is-loading');

      Promise.resolve()
        .then(addToCart)
        .then(function () {
          if (window.PubSub) window.PubSub.publish('cart-drawer:open');
        })
        .catch(function () {
          var url = wrapper.getAttribute('data-product-url');
          if (url) window.location.href = url;
        })
        .finally(function () {
          wrapper.classList.remove('is-loading');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
